import $ from 'jquery'
import renderNotRenderedTooltips from 'utils/MiscUtils/renderNotRenderedTooltips'

// The only purpose of the code below is to render react tooltips
// which are received on AJAX-request.
$(document).ajaxSuccess(renderNotRenderedTooltips)
